import _ from 'lodash';
import promiseError from 'libs/promiseError';
import { FETCH_AUTHORIZED_LABS } from 'actions/types';

const fetchLabs = (action, state) => {
  const { payload } = action;
  const { status, request, data } = payload;

  if (status === 200) {
    if (data) {
      return _.mapKeys(data.data, 'id');
    }
    return state;
  } else {
    const fetchError = promiseError(request);
    return { ...state, fetchError };
  }
};

export default function(state = null, action) {
  switch (action.type) {
    case FETCH_AUTHORIZED_LABS:
      return fetchLabs(action, state);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/labs.js